import PubSub from "underpub-js";
import gsap from "gsap";
import Cookies from 'js-cookie';

var LeasingPopup = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-LeasingPopup',
	};

	$.extend(true, this.options, options);

	//
	// This will get created dynamically during the init method, based on
	// the actual slides we have.
	// eg: closed, small, big
	//
	this.componentState = "closed";
	this.currentSlideIndex = 0;

};

LeasingPopup.prototype.init = function() {

	var self = this;

	this.$closeIcon = false;
	this.$collapseIcon = false;
	this.$slides = this.options.$el.find(".el-LeasingPopupSlide");
	this.$smallContainer = this.options.$el.find(".js-small-container");
	this.$bigContainer = this.options.$el.find(".js-big-container");

	let realInit = function(){
		self.$circleButton = self.options.$el.find(".js-circle-button");
		self.$closeIcon = self.options.$el.find(".js-close-icon");
		self.$collapseIcon = self.options.$el.find(".js-collapse-icon");
		self.$closeIcon.addClass("is-active");
		self.initTransitions();

		self.$smallContainer.on("click", function(){
			if(typeof gtag !== "undefined"){
				gtag('event', 'leasing_widget_open', {
					'event_category': 'leasing_widget'
				});
			}
			self.transitionSmallToBig();
		});

		self.$circleButton.on("click", function(){
			if(self.componentState === "big"){
				if(typeof gtag !== "undefined"){
					gtag('event', 'leasing_widget_collapse', {
						'event_category': 'leasing_widget'
					});
				}
				self.transitionBigToSmall();
			}else if(self.componentState === "small"){
				if(typeof gtag !== "undefined"){
					gtag('event', 'leasing_widget_close', {
						'event_category': 'leasing_widget'
					});
				}

				if (self.options.$el.data('closeDuration') > 0) {
					var cookieExpiryTime = new Date(new Date().getTime() + self.options.$el.data('closeDuration') * 60 * 1000);
					Cookies.set('leasingPopupClosed', 'true', { expires: cookieExpiryTime });
				}

				self.transitionCloseSmall();
			}
		});

		// showing the button on page load
		setTimeout(function(){
			self.transitionOpenSmall();
		}, 1000);

	};

	PubSub.subscribe('Sitewide:inlineSvgs:svgReplaced', function(){
		realInit();
	});

	PubSub.subscribe('LeasingPopup.handleSelectorButtonClick', function(customSlideIndex){
		customSlideIndex = Number(customSlideIndex);
		self.gotoSlide(self.currentSlideIndex += customSlideIndex);
	});

	PubSub.subscribe('LeasingPopup.showThankyou', function(){
		self.gotoSlide((self.$slides.length - 1));
		setTimeout(function(){
			self.transitionCloseBig();
		}, 4000);
	});

};

LeasingPopup.prototype.transitionOpenSmall = function(){
	this.showCloseButton();
	this.showSmallTimeline.play();
	this.componentState = "small";
};

LeasingPopup.prototype.transitionCloseSmall = function(){
	this.showCloseButton();
	let self = this;
	let timeline = gsap.timeline({paused: true, onComplete: function() {
		self.componentState = "closed";
		gsap.set(self.options.$el, {display: "none", opacity: 0});
	}});
	timeline.add(this.showSmallTimeline.timeScale(1.25).reverse());
	timeline.play();
};

LeasingPopup.prototype.transitionCloseBig = function(){
	let self = this;
	let timeline = gsap.timeline({paused: true, onComplete: function() {
		self.componentState = "closed";
		gsap.set(self.options.$el, {display: "none", opacity: 0});
	}});
	timeline.add(this.showBigTimeline.timeScale(1.25).reverse());
	timeline.play();
};

LeasingPopup.prototype.transitionSmallToBig = function(){
	let self = this;
	let timeline = gsap.timeline({paused: true, onComplete: function() {
		self.componentState = "big";
	}});
	timeline.add(this.showSmallTimeline.timeScale(1.25).reverse());
	timeline.call(function(){
		self.gotoSlide(0);
		self.showCollapseButton();
	});
	timeline.delay(10);
	timeline.add(this.showBigTimeline.play(), "+=.25");
	timeline.play();
};

LeasingPopup.prototype.transitionBigToSmall = function(){
	let self = this;
	let timeline = gsap.timeline({paused: true, onComplete: function() {
		self.componentState = "small";
	}});
	timeline.add(this.showBigTimeline.timeScale(1.25).reverse());
	timeline.call(function(){
		self.showCloseButton()
	});
	timeline.delay(10);
	timeline.add(this.showSmallTimeline.play(), "+=.25");
	timeline.play();
};

LeasingPopup.prototype.initTransitions = function(){

	var self = this;

	//
	// Show Small Timeline
	//
	this.showSmallTimeline = gsap.timeline({
		paused: true,
		onStart: function(){
			gsap.set(self.options.$el, {display: "block", opacity: 1});
			gsap.set(self.$smallContainer, {display: "flex", opacity: 0});
			gsap.set(self.$bigContainer, {display: "none", opacity: 0});
			gsap.set(self.$circleButton, {display: "flex"});
		}
	});

	this.showSmallTimeline.fromTo([this.$circleButton, this.$smallContainer], {
		opacity: 0,
		y: 40
	}, {
		opacity: 1,
		y: 0,
		ease: "Expo.easeOut",
		duration: .5,
		stagger: .05,
	});

	//
	// Show Big Timeline
	//
 	this.showBigTimeline = gsap.timeline({
		paused: true,
		onStart: function(){
			gsap.set(self.options.$el, {display: "block", opacity: 1});
			gsap.set(self.$smallContainer, {display: "none", opacity: 0});
			gsap.set(self.$bigContainer, {display: "flex", opacity: 0, visibility: "visible"});
			gsap.set(self.$circleButton, {display: "flex"});
		}
	});
	this.showBigTimeline.fromTo([this.$bigContainer, this.$circleButton], {
		opacity: 0,
		y: 40
	}, {
		opacity: 1,
		y: 0,
		ease: "Expo.easeOut",
		duration: .5,
		stagger: .1,
	});

};

LeasingPopup.prototype.showCloseButton = function(){
	let self = this;
	gsap.set(self.$closeIcon, {opacity: 1});
	gsap.set(self.$collapseIcon, {opacity: 0})
};

LeasingPopup.prototype.showCollapseButton = function(){
	let self = this;
	gsap.set(self.$closeIcon, {opacity: 0});
	gsap.set(self.$collapseIcon, {opacity: 1})
};

LeasingPopup.prototype.gotoSlide = function(slideIndex){
	let self = this;
	gsap.set(self.$slides, {opacity: 0, zIndex: -10});
	gsap.set(self.$slides[slideIndex], {opacity: 1, zIndex: 1});
	this.currentSlideIndex = slideIndex;
};

export default LeasingPopup;
